import { convertArrayToObject } from '../array-utils';
import { createFetchedData } from './create-fetched-data';
/**
 * Takes in a list of data, converts it to FetchedData form,
 * then converts it to dictionary form.
 *
 * @param payloadList The list of data to convert.
 * @param keySelector The key selector.
 * @param cacheDuration The cache duration of the payload.
 */
export const createFetchedDataRecord = (payloadList, keySelector, cacheDuration) => {
    return convertArrayToObject(payloadList, keySelector, payload => createFetchedData(payload, cacheDuration));
};
